"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelDrawableLine = exports.CollectionModelDrawableLineMutator = void 0;
var tslib_1 = require("tslib");
var drawable_1 = require("./drawable");
var CollectionModelDrawableLineMutator = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelDrawableLineMutator, _super);
    function CollectionModelDrawableLineMutator(drawable) {
        return _super.call(this, drawable) || this;
    }
    CollectionModelDrawableLineMutator.prototype.init = function (startPoint, endPoint, labelPoint) {
        var startId = "".concat(this.drawable.id, ":start");
        var endId = "".concat(this.drawable.id, ":end");
        var labelId = "".concat(this.drawable.id, ":label");
        this.drawable.drawableState.Mutator.create('line-point', startId, this.drawable.id);
        this.drawable.drawableState.Mutator.create('line-point', endId, this.drawable.id);
        this.drawable.drawableState.Mutator.create('label', labelId, this.drawable.id);
        var state = this.getValue();
        state.startId = startId;
        state.endId = endId;
        state.labelId = labelId;
        this.setValue(state);
        var start = this.drawable.start;
        var end = this.drawable.end;
        var label = this.drawable.label;
        start.Mutator.init(startPoint.x, startPoint.y);
        end.Mutator.init(endPoint.x, endPoint.y);
        label.Mutator.move(labelPoint.x, labelPoint.y);
    };
    return CollectionModelDrawableLineMutator;
}(drawable_1.CollectionModelDrawableMutator));
exports.CollectionModelDrawableLineMutator = CollectionModelDrawableLineMutator;
var CollectionModelDrawableLine = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelDrawableLine, _super);
    function CollectionModelDrawableLine() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tag = CollectionModelDrawableLine.TAG;
        _this.Mutator = new CollectionModelDrawableLineMutator(_this);
        return _this;
    }
    CollectionModelDrawableLine.state = function (id, parentId) {
        return {
            id: id,
            parentId: parentId,
            tag: 'line',
            labelId: null,
            startId: null,
            endId: null,
            x: 0,
            y: 0
        };
    };
    CollectionModelDrawableLine.isLine = function (t) {
        return t.tag === CollectionModelDrawableLine.TAG;
    };
    Object.defineProperty(CollectionModelDrawableLine.prototype, "start", {
        get: function () {
            return this.drawableState.getDrawable(this.state.startId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableLine.prototype, "end", {
        get: function () {
            return this.drawableState.getDrawable(this.state.endId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableLine.prototype, "label", {
        get: function () {
            return this.drawableState.getDrawable(this.state.labelId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableLine.prototype, "value", {
        get: function () {
            return this.drawableState.collection.state
                .getGeometry(this.captureId)
                .calculateDistance(this.start.getVector(), this.end.getVector());
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableLine.TAG = 'line';
    return CollectionModelDrawableLine;
}(drawable_1.CollectionModelDrawable));
exports.CollectionModelDrawableLine = CollectionModelDrawableLine;
//# sourceMappingURL=line.drawable.js.map